export const removeSpecialChartersAndWhiteSpace = (inputString) => inputString
  .replace(/[^\s\w]/g, '')
  .trim()
  .replace(/\s+/g, '-')
  .toLowerCase();
